import React from "react";
import { CounterCard, CounterLabel, CounterValue } from "./Counter.elements";

const Counter = (props) => {
    return (
        <CounterCard>
            <CounterLabel title={props.title}>{props.title}</CounterLabel>
            <CounterValue>{props.count}</CounterValue>
        </CounterCard>
    );
};

export default Counter;
